export default "__VITE_ASSET__D3x7QkMz__"